import Slider from 'rc-slider';
import React, { useState, useEffect, useRef,useImperativeHandle, forwardRef } from "react";
import { useDebounce } from '../../Hooks/debounce';

export const SportRouteSlider = forwardRef((props, ref) => {
    const { label, className, text, passSliderValue, name, min, max } = props

    const [sliderText, setSliderText] = useState(text);
    const [isOpen, setIsOpen] = useState(false);
    const [sliderValue, setSliderValue] = useState();

    const dropdownRef = useRef(null);
    const dropdownRefOpen = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target) && dropdownRefOpen.current && !dropdownRefOpen.current.contains(event.target)) {
            setIsOpen(false);
          }
        }
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [dropdownRef]);

    const handleSliderToggle = () => {
        setIsOpen(!isOpen);
    }

    const handleSliderValueChange = (value) => {
        setSliderValue(value);
        setNewText(value);
    }

    const resetFilter = () => {
        setSliderValue(min);
        setSliderText(text);
    }

    useImperativeHandle(ref, () => ({
        resetFilter,
    }));

    const debouncedValue = useDebounce(sliderValue, 1000);

    useEffect(() => {
        if(!sliderValue){
            return
        }

        const sliderData = {
            'min': min,
            'max': sliderValue
        }
        passSliderValue(name, sliderData);
        setIsOpen(!isOpen);
    }, [debouncedValue])

    const setNewText = (sliderValue) => {
        if(sliderValue === max){
            setSliderText(`${sliderValue} KM`)
        }
        else if(sliderValue === min){
            setSliderText(`${sliderValue} KM`)
        }
        else{
            setSliderText(`${min} - ${sliderValue} KM`)
        }
    }

    return(
        <div 
            ref={dropdownRef}
            className='c-slider-dropdown__container'
        >
            <div 
                className={`c-input ${isOpen ? "isOpen" : ""} slider` + className}
                onClick={handleSliderToggle}
            >
                <label className="c-input__label">{label}</label>
                <div 
                    className='c-input__field c-slider__placeholder'
                >
                    {sliderText &&
                        <p className="">{sliderText}</p>
                    }
                </div>
            </div>
            {isOpen ?
                <div className='c-slider__container' ref={dropdownRefOpen}>
                    <Slider 
                        min={min}
                        max={max}
                        marks={{0:"0 KM", 50:"50 KM", 100: "100 KM", 150: "150 KM", 200: "200 KM"}}
                        onChange={handleSliderValueChange}
                        value={sliderValue}
                    />
                </div>
            :
                <span></span>
            }
        </div>
    );
});

SportRouteSlider.defaultProps = {
    label: "Label",
    options: [
      "Placeholder",
      "optie1",
      "optie2",
      "optie3",
      "optie4",
      "optie5",
      "optie6",
    ],
    className: ""
  };